/* eslint no-console: "off",  react/no-multi-comp: "off"*/

import React from 'react';
import { withRouter } from 'react-router-dom';
import AuthClient from '@bridge/auth-js';
import Authenticator from './reusable/Authenticator';
import _util from 'lodash/util';

const authClient = new AuthClient(window.authClient);

/**
 * Add renewAuth on render
 * @param {React.Component} InnerComponent React component to add authorization handling
 */
const withRenewingAuthentication = InnerComponent => {
  class WithAuthenticating extends React.Component {
    constructor(props) {
      super(props);
      const self = this;

      self.state = {
        accessToken: ''
      };

      Authenticator.authenticate(authClient).then(accessToken => {
        self.setState({
          accessToken
        });
      });
    }

    render() {
      const self = this;

      if (self.state.accessToken) {
        return <InnerComponent accessToken={self.state.accessToken} {...self.props} />;
      } else {
        return null;
      }
    }
  }

  return WithAuthenticating;
};

/**
 * Inject authClient into props
 * @param {React.Component} InnerComponent React component to add authClient to
 */
const withAuthClient = InnerComponent => {
  const WithAuthClient = function(props) {
    return <InnerComponent authClient={authClient} {...props} />;
  };

  return WithAuthClient;
};

/**
 * Enhances component by adding authenticating and router props.
 * @param {React.Component} InnerComponent
 */
const useAuthentication = InnerComponent => {
  return _util.flowRight(
    withRenewingAuthentication,
    withRouter
  )(InnerComponent);
};

/**
 * Enhances component by adding authClient and router props.
 * @param {React.Component} InnerComponent
 */
const useAuthClient = InnerComponent => {
  return _util.flowRight(
    withAuthClient,
    withRouter
  )(InnerComponent);
};

export default {
  useAuthentication,
  useAuthClient
};



// WEBPACK FOOTER //
// ./src/components/compose.js